module.exports = __webpack_public_path__ + "img/banner8.a3b1379f.png";